import React from 'react';
import { Modal } from 'react-bootstrap';
import Parser from 'html-react-parser';
import LoginService from '../../services/login-service';
import AuthService from '../../services/auth-service';
import icon2 from '../../img/icon2.png';
import Loading from '../../components/loading';
import { IStoreResponse } from '../../interfaces/store';

export default class Login extends React.Component<{ history: any }> {
    state = {
        usuario: '' as string,
        senha: '' as string,
        error: '' as string,
        logado: '' as string,
        isLoading: false
    };

    async componentWillUnmount() {
        localStorage.removeItem('@MomentaMais/userId');
        AuthService.logout();
    }

    handleSignIn = async (e: any) => {
        e.preventDefault();

        const { usuario, senha } = this.state;

        if (!usuario || !senha)
            this.setState({ error: "Preencha e-mail e senha para continuar!" });
        else {
            try {
                var username: string = this.state.usuario;
                var password: string = this.state.senha;
                this.setState({ isLoading: true });
                let loginService = new LoginService();
                var response = await LoginService.getLogin(username, password, false);

                if (!response.data.error) {
                    AuthService.login(response.data.token);
                    localStorage.setItem('@MomentaMais/userId', response.data.data.user.id);
                    this.state.logado = 'logado';
                    this.props.history.push('/coupon-builder');
                    this.setState({ isLoading: false });
                }
                else {
                    this.setState({ error: "Não foi possível logar.<br/>Verifique suas credenciais." });
                    this.setState({ isLoading: false });
                }
            }
            catch (err) {
                this.setState({ error: "Houve um problema com o login.<br/>Verifique suas credenciais." });
                this.setState({ isLoading: false });
            }
        }
    };
    render() {

        const { isLoading } = this.state;

        return (

            <div className="header__form">
                <a href="#" className="header__logo-1">
                    <img src={icon2} alt="" />
                </a>
                <div>
                    <p className="p-text">
                        Login
                    </p>
                    <form onSubmit={this.handleSignIn}>
                        <div className="form-group">
                            <input
                                id="usuario"
                                type="text"
                                placeholder="*Usuário"
                                onChange={e => this.setState({ usuario: e.target.value })}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                id="senha"
                                type="password"
                                placeholder="*Senha"
                                onChange={e => this.setState({ senha: e.target.value })}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-button">
                            <button
                                type="submit"
                                className="btn-primary"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Entrando...' : 'Entrar'}
                            </button>
                            {
                                this.state.error &&
                                <div className="h4 text-danger">
                                    {Parser(this.state.error)} 
                            </div>
                            }
                        </div>
                    </form>
                </div>
                <Loading show={isLoading} />
            </div>
        );
    }
}